<div class="client-container">
  <!-- Toolbar -->
  <div class="searchRow">
    <div class="toolbar-left">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         (click)="refresh()"
         ap-tooltip [tooltipContent]="'Refresh Data'" [direction]="'right'"></i>
      <button class="btn btn-success btn-xs add-client-btn" (click)="addNewClient()" id="add-new-client">
        <i class="fa fa-plus"></i> Add New Client
      </button>
    </div>
    <div class="toolbar-right">
      <div class="searchDiv">
        <div class="searchBlock">
          <input type="text" class="contentSearch"
                 [ngModel]="searchClient"
                 (ngModelChange)="onSearchChange($event)"
                 placeholder="Search Client...">
        </div>
        <i class="fa fa-search searchIcons"></i>
      </div>
    </div>
  </div>

  @if (refreshMoment) {
<div class="refresh-notice">
    <label>Data refreshed at {{ refreshMoment }}</label>
  </div>
}

  <!-- Loader -->
  @if (loading) {
<div class="loading-indicator">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
  </div>
}

  <!-- No clients -->
  @if (!loading && filteredClientList.length === 0) {
<div class="noClients">
    No clients to display.
  </div>
}

  <!-- Client cards -->
  @if (!loading && filteredClientList.length > 0) {
<div class="client-list">
    @for (client of filteredClientList; track trackByClientKey($index, client)) {
<div class="client-card"
        >
      <!-- Logo -->
      <div class="client-logo">
        @if (client.logo_url) {
<img [src]="client.logo_url" class="img-responsive" alt="" />
}
        @if (!client.logo_url) {
<div class="logo-placeholder">
          <i class="fa fa-building-o"></i>
        </div>
}
      </div>

      <!-- Info block 1 -->
      <div class="client-info">
        <div><label>Client Name:</label> <span>{{ client.client_name }}</span></div>
        <div><label>Client Key:</label> <span>{{ client.client_key }}</span></div>
        <div class="text-limit"><label>Client Description:</label> <span>{{ client.client_desc }}</span></div>
      </div>

      <!-- Info block 2 -->
      <div class="client-info">
        <div><label>Client Size:</label> <span>{{ client.client_size }}</span></div>
        <div><label>Is Active?:</label> <span>{{ client.client_active === '1' ? 'Yes' : 'No' }}</span></div>
        <div><label>Datasource Name:</label> <span class="text-upper">{{ client.client_datasource }}</span></div>
      </div>

      <!-- Info block 3 -->
      <div class="client-info client-info--bordered">
        <div><label>Status:</label> <span>{{ client.client_status || 'No Info Available' }}</span></div>
        <div><label>Progress:</label>
          <span>{{ client.process_step_description
            ? (client.process_step_description + ' (' + client.current_step + '/4) ' + client.step_status)
            : 'No Info Available' }}</span>
        </div>
        <div><label>RDS Source:</label> <span>{{ client.rds_inst_src_snapshot_id }}</span></div>
      </div>

      <!-- Actions -->
      <div class="client-actions">
        @if (client.client_key === '0') {
<i
           class="fa fa-hand-o-up action-icon"
           (click)="push()"
           ap-tooltip [tooltipContent]="'Push'" [direction]="'left'"></i>
}

        <i class="fa fa-pencil-square-o action-icon"
           (click)="editClient(client)"
           ap-tooltip [tooltipContent]="'Edit Client'" [direction]="'left'"></i>

        <div class="toggle-wrapper"
             ap-tooltip [tooltipContent]="'Enable/Disable Client'" [direction]="'left'">
          <ap-toggle
            [ngModel]="client.client_active === '1'"
            [disabled]="isLoggedInClient(client.client_key)"
            [ariaLabel]="'Enable or disable client'"
            (onChange)="toggleClientActive(client, $event)">
          </ap-toggle>
        </div>

        @if (client.client_key > '0' && client.client_key !== '999') {
<i
           class="fa fa-minus-circle action-icon action-icon--danger"
           (click)="confirmRemoveClient(client)"
           ap-tooltip [tooltipContent]="'Remove Client'" [direction]="'left'"></i>
}
      </div>
    </div>
}
  </div>
}

  <!-- Confirm delete overlay -->
  @if (showConfirmDelete) {
<div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmDeleteConfig"
      [visible]="false"
      (confirmed)="onConfirmDeleteYes()"
      (cancelled)="onConfirmDeleteNo()"
      (closed)="onConfirmDeleteNo()">
    </gtw-confirmation-modal>
  </div>
}
</div>
